import { render, staticRenderFns } from "./TaskTipTapEditor.vue?vue&type=template&id=2cd430ff&"
import script from "./TaskTipTapEditor.vue?vue&type=script&lang=js&"
export * from "./TaskTipTapEditor.vue?vue&type=script&lang=js&"
import style0 from "./TaskTipTapEditor.vue?vue&type=style&index=0&id=2cd430ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports